import { useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getQueryString = () => {
    return searchParams.toString();
  };

  const getQueryParamsObject = () => {
    const result = {};
    for (const [key, value] of searchParams.entries()) {
      result[key] = value;
    }
    return result;
  };

  const updateQueryParams = (params) => {
    const currentParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      if (value === "" || value === undefined || value === null) {
        currentParams.delete(key);
      } else {
        currentParams.set(key, value);
      }
    });
    setSearchParams(currentParams);
  };

  const resetQueryParams = () => {
    setSearchParams();
  };

  return {
    searchParams,
    getQueryString,
    getQueryParamsObject,
    updateQueryParams,
    resetQueryParams,
  };
};

export default useQueryParams;
